import React, { useState } from 'react';
import ChangeDialog from '../dialogs/ChangeDialog';
import "../../../stylesheets/triagebot/Footer.scss"
import { useDetectMobile, useDetectTablet } from '../utils';
import { useGlobalContext } from '../../../context/global-context-provider'; 



const Footer = ({ children, showChangeButton, onAccepted, onDenied, disabled, divID, message }) => {

    const changeButton = message?.data?.[0]?.changebutton
    ? message.data[0].changebutton
    : '';

    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const {isMobile}  = useDetectMobile();
    const {isTablet}  = useDetectTablet();
    const isDesktop = !isMobile && !isTablet;
    const { cdoName: globalCdoName } = useGlobalContext();

    const cdoName = globalCdoName||process.env.REACT_APP_CDO_NAME || '';
    const isOpenCdo = cdoName.toLowerCase() === 'open';

    if (!(onAccepted instanceof Function))
        onAccepted = () => { };

    if (!(onDenied instanceof Function))
        onDenied = () => { };

    const dialogResponse = (response) => {
        response ? onAccepted() : onDenied();
        handleOnClose();
    }

    const handleChangeOutline=()=>{
        setIsDialogOpen(true);

        document.activeElement.blur();
    }

    const handleOnClose = () => {
        setIsDialogOpen(false);
        var buttonID = divID+'-button';
        var cancelButton = document.getElementById(buttonID);
        var currentElement = document.getElementById(divID);
        
        setTimeout(()=>{
            cancelButton.focus();
        }, 100); 

        if(currentElement) {
            currentElement.scrollIntoView({behavior: 'smooth',block: 'start'});
        }      
    }

    return (
        <div className={(isOpenCdo && isDesktop ? ' open-card-footer':' card-footer')}>
            { children}
            {
                showChangeButton &&
                <button id={divID+'-button'}
                    className={(disabled ? 'disabled ' : '' ) + (isDesktop ? 'desktop ' : 'mobile ') + 'change-button' + (isOpenCdo ? ' open-change-button' : '')}
                    onClick={handleChangeOutline}
                    disabled={disabled}
                    >
                        <svg width="25" height="24" className="vector-icon" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.2 14.2C16.3833 14.2833 16.571 14.2917 16.763 14.225C16.9543 14.1583 17.0833 14.0333 17.15 13.85C17.2833 13.55 17.375 13.246 17.425 12.938C17.475 12.6293 17.5 12.3167 17.5 12C17.5 11.3667 17.3793 10.7373 17.138 10.112C16.896 9.48733 16.5333 8.93333 16.05 8.45C15.5667 7.96667 15.021 7.60833 14.413 7.375C13.8043 7.14167 13.1833 7.025 12.55 7.025L13 6.575C13.15 6.425 13.221 6.25 13.213 6.05C13.2043 5.85 13.125 5.675 12.975 5.525C12.825 5.375 12.65 5.3 12.45 5.3C12.25 5.3 12.075 5.375 11.925 5.525L9.95 7.475C9.85 7.575 9.8 7.69167 9.8 7.825C9.8 7.95833 9.85 8.075 9.95 8.175L11.925 10.125C12.075 10.2583 12.25 10.329 12.45 10.337C12.65 10.3457 12.825 10.275 12.975 10.125C13.125 9.975 13.2 9.8 13.2 9.6C13.2 9.4 13.125 9.225 12.975 9.075L12.4 8.5C12.85 8.5 13.3083 8.58733 13.775 8.762C14.2417 8.93733 14.6417 9.19167 14.975 9.525C15.3083 9.85833 15.5627 10.2417 15.738 10.675C15.9127 11.1083 16 11.5417 16 11.975C16 12.175 15.9877 12.375 15.963 12.575C15.9377 12.775 15.8833 12.9667 15.8 13.15C15.7167 13.3833 15.7127 13.5957 15.788 13.787C15.8627 13.979 16 14.1167 16.2 14.2ZM12.025 18.475C12.175 18.625 12.35 18.7 12.55 18.7C12.75 18.7 12.925 18.625 13.075 18.475L15.05 16.525C15.15 16.425 15.2 16.3083 15.2 16.175C15.2 16.0417 15.15 15.925 15.05 15.825L13.075 13.875C12.925 13.7417 12.75 13.6707 12.55 13.662C12.35 13.654 12.175 13.725 12.025 13.875C11.875 14.025 11.8 14.2 11.8 14.4C11.8 14.6 11.875 14.775 12.025 14.925L12.575 15.475C12.1083 15.4917 11.6543 15.4167 11.213 15.25C10.771 15.0833 10.375 14.825 10.025 14.475C9.69167 14.1417 9.43733 13.7583 9.262 13.325C9.08733 12.8917 9 12.4583 9 12.025C9 11.8083 9.01267 11.604 9.038 11.412C9.06267 11.2207 9.11667 11.025 9.2 10.825C9.26667 10.6417 9.275 10.4623 9.225 10.287C9.175 10.1123 9.075 9.975 8.925 9.875C8.725 9.74167 8.51233 9.70833 8.287 9.775C8.06233 9.84167 7.90833 9.975 7.825 10.175C7.69167 10.475 7.604 10.7707 7.562 11.062C7.52067 11.354 7.5 11.6667 7.5 12C7.5 12.6333 7.625 13.2583 7.875 13.875C8.125 14.4917 8.49167 15.0417 8.975 15.525C9.45833 16.0083 10 16.371 10.6 16.613C11.2 16.8543 11.8167 16.9833 12.45 17L12.025 17.425C11.875 17.575 11.8 17.75 11.8 17.95C11.8 18.15 11.875 18.325 12.025 18.475ZM12.5 22C11.1167 22 9.81667 21.7373 8.6 21.212C7.38333 20.6873 6.325 19.975 5.425 19.075C4.525 18.175 3.81267 17.1167 3.288 15.9C2.76267 14.6833 2.5 13.3833 2.5 12C2.5 10.6167 2.76267 9.31667 3.288 8.1C3.81267 6.88333 4.525 5.825 5.425 4.925C6.325 4.025 7.38333 3.31233 8.6 2.787C9.81667 2.26233 11.1167 2 12.5 2C13.8833 2 15.1833 2.26233 16.4 2.787C17.6167 3.31233 18.675 4.025 19.575 4.925C20.475 5.825 21.1873 6.88333 21.712 8.1C22.2373 9.31667 22.5 10.6167 22.5 12C22.5 13.3833 22.2373 14.6833 21.712 15.9C21.1873 17.1167 20.475 18.175 19.575 19.075C18.675 19.975 17.6167 20.6873 16.4 21.212C15.1833 21.7373 13.8833 22 12.5 22ZM12.5 20C14.7167 20 16.6043 19.221 18.163 17.663C19.721 16.1043 20.5 14.2167 20.5 12C20.5 9.78333 19.721 7.89567 18.163 6.337C16.6043 4.779 14.7167 4 12.5 4C10.2833 4 8.396 4.779 6.838 6.337C5.27933 7.89567 4.5 9.78333 4.5 12C4.5 14.2167 5.27933 16.1043 6.838 17.663C8.396 19.221 10.2833 20 12.5 20Z" className="change-icon-hover" />
                        </svg>
                    {changeButton}
                </button>
            }
            {
                showChangeButton &&
                <ChangeDialog
                    message = {message}
                    isDialogOpen={isDialogOpen}
                    onClose={handleOnClose}
                    isAccepted={dialogResponse}
                    disabled={disabled}
                    cdoName={cdoName}
                />
            }
        </div >
    )
}

export default Footer;